
import { Spinner } from 'react-bootstrap';
import React, { useState, useEffect } from 'react';
import "../../CSS/DataModal.css";

const HvacConfirmationModal = ({ show, title, loading, onSubmitHVACSystemName, onCancelClick, initialHVACName = '' }) => {
    const [inputValue, setInputValue] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        if (show) {
            setInputValue(initialHVACName);
            setError('');
        }
    }, [show, initialHVACName]);
    
    const handleInputChange = (e) => {
        setInputValue(e.target.value);
        if (error) setError('');
    };

    const handleSubmit = () => {
        if (!inputValue.trim()) {
            setError('HVAC system name cannot be empty.');
            return;
        }
        if (onSubmitHVACSystemName) {
            onSubmitHVACSystemName(inputValue); 
        }
    };

    const handleCancel = (e) => {
        onCancelClick && onCancelClick(e); 
        setInputValue('');
        setError('');
    };

    if (!show) return null;

    return (
        <div className="modal" style={{ display: show ? "block" : "none" }}>
            <div
                className="modal-wrapper"
                style={{
                    transform: show ? 'translateY(0vh)' : 'translateY(-100vh)',
                    opacity: show ? '1' : '0'
                }}
            >
                <div className="modal-header">
                    <h3>{title}</h3>
                    <span className="close-modal-btn" onClick={handleCancel}>×</span>
                </div>

                <div className="modal-body">
                    <div className="form-row form-data">
                        <p className="label-text">HVAC system name : </p>
                        <input
                            type="text"
                            className="input-text input-half"
                            placeholder="Enter hvac system name"
                            value={inputValue}
                            onChange={handleInputChange}
                        />
                    </div>
                            {error && (
                                <p className="error-text" >{error}</p>
                            )}
                       
                </div>

                <div className="modal-footer">
                    <button className="secondary-btn btn-small" onClick={handleCancel}>
                        Cancel
                    </button>
                    <button className="primary-btn btn-small" disabled={loading} onClick={handleSubmit}>
                        Submit
                    </button>
                </div>
            </div>
        </div>
    );
};

export default HvacConfirmationModal;
